import { useState } from 'react'
import { SaveTemplateUseCase } from '../../usecases/SaveTemplateUseCase'
import { AxiosTemplateRepository } from '../../infrastructure/AxiosTemplateRepository'
import { Template } from '../../domain/entities/Template'

export function useSaveTemplate() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const saveTemplate = async (template: Template): Promise<Template> => {
    setLoading(true)
    setError(null)
    try {
      const useCase = new SaveTemplateUseCase(new AxiosTemplateRepository())
      const result = await useCase.execute(template)
      return result
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : String(err)
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return { saveTemplate, loading, error }
}
